<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path class="fillActive fillDefault" d="M2 6.90039L11.8 6.90078" stroke="#505050" stroke-width="1.5" stroke-linecap="round"/>
</svg>
